import { EventEmitter } from './EventEmitter';
import { getFetch } from '../platform/getFetch/browser';
import { getEventSource } from '../platform/getEventSource/browser';
import { BrowserSignalListener } from '@splitsoftware/splitio-commons/esm/listeners/browser';
import { now } from '@splitsoftware/splitio-commons/esm/utils/timeTracker/now/browser';
export var platform = {
    getFetch: getFetch,
    getEventSource: getEventSource,
    EventEmitter: EventEmitter,
    now: now
};
export var SignalListener = BrowserSignalListener;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/platform/browser.js
// module id = 3943
// module chunks = 25